import React from "react";
import "../style/TestimonySection.css";
import user1 from "../assets/testimony/user1.png";
import user2 from "../assets/testimony/user2.png";
import user3 from "../assets/testimony/user3.png";

const testimonialsGroup = [
  [
    {
      text: "Made our job scheduling faster and easier. Brilliant system.",
      name: "Gino",
      title: "Gino’s Gas Services",
      img: user1,
    },
    {
      text: "Saves us time every week. Couldn’t be happier with it.",
      name: "Tyler",
      title: "Infinit Property Services",
      img: user2,
    },
    {
      text: "Helps us stay organised and on top of every project.",
      name: "Deniz",
      title: "D.O Joinery",
      img: user3,
    },
  ],
  [
    {
      text: "Fantastic tool. Streamlined our workflow from day one.",
      name: "Liam ",
      title: "Imperial Engineering",
      img: user3,
    },
    {
      text: "Simple, powerful, and perfect for keeping track of clients.",
      name: "Adam",
      title: "H2O Window Cleaning",
      img: user2,
    },
    {
      text: "Transformed how we manage projects and communicate with clients.",
      name: "Lewis ",
      title: "LDL Quantity Surveyors",
      img: user1,
    },
  ],
  // [
  //   {
  //     text: "Our payroll process is now faster and error-free. Couldn't be happier with the results!",
  //     name: "James Rodriguez",
  //     title: "Finance Head, NovaCore",
  //     img: user2,
  //   },
  //   {
  //     text: "It has transformed how we handle onboarding and compliance tracking. Love it!",
  //     name: "Priya Desai",
  //     title: "HR Partner, TeamEdge",
  //     img: user1,
  //   },
  //   {
  //     text: "The automation and accuracy have truly set this platform apart from competitors.",
  //     name: "Leo Grant",
  //     title: "COO, InnovateX",
  //     img: user3,
  //   },
  // ],
];

const TestimonySection = () => {
  const directions = ["up", "down", "up"];

  return (
    <section className="testimony-section" id="testimonials">
      <div className="container">
        <h2 className="testimony-title">Trusted by Local Trades</h2>
        <p className="testimony-subtitle">See what our customers have to say</p>

        {/* Desktop */}
        <div className="testimony-scroll-container desktop">
          {testimonialsGroup.map((group, i) => (
            <div
              key={i}
              className={`scroll-column ${directions[i] === "down" ? "scroll-down" : "scroll-up"
                }`}
            >
              <div className="scroll-inner">
                {[...group, ...group].map((t, idx) => (
                  <div key={idx} className="testimonial-card">
                    <p className="testimonial-text">{t.text}</p>
                    <div className="testimonial-user">
                      {/* <img src={t.img} alt={t.name} className="testimonial-img" /> */}
                        <p className="testimonial-name">{t.name}</p>
                        <p className="testimonial-title">{t.title}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Mobile */}
        <div className="testimony-scroll-container mobile">
          <div className="scroll-column scroll-down">
            <div className="scroll-inner">
              {[...testimonialsGroup.flat(), ...testimonialsGroup.flat()].map(
                (t, idx) => (
                  <div key={idx} className="testimonial-card">
                    <p className="testimonial-text">{t.text}</p>
                    <div className="testimonial-user">
                      {/* <img
                        src={t.img}
                        alt={t.name}
                        className="testimonial-img"
                      /> */}
                        <p className="testimonial-name">{t.name}</p>
                        <p className="testimonial-title">{t.title}</p>
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonySection;
